import moment from 'moment'

import { type SubmitCreditCardBillPayload } from '@webapp/modules/accounts-payable/business-logic/interfaces/IReconcileSessionRepository'

// Narrow input owned by this mapper (option objects + Moment dates from the
// bill form). The presenter wires the View's `CreditCardBillFormSchema` into
// this shape; the mapper extracts ids and formats YYYY-MM-DD dates.
export interface MapCreditCardBillFormSchemaToPayloadInput {
  notes: string
  paymentMethod: Nullable<{ value: number }>
  dueDate: Nullable<moment.Moment>
  invoiceDate: moment.Moment
  approvalChain: Nullable<{ value: number }>
  approver: Nullable<{ value: number; userId: number }>
  invoiceAttachmentUuids: string[]
}

const DATE_FORMAT = 'YYYY-MM-DD'

// PUT sessions/{id}/ bill submission (status: 1, BHV-049).
export const mapCreditCardBillFormSchemaToPayload = (
  input: MapCreditCardBillFormSchemaToPayloadInput
): SubmitCreditCardBillPayload => ({
  note: input.notes,
  approval_chain: input.approvalChain?.value ?? null,
  approver: input.approver
    ? { id: input.approver.value, user: { id: input.approver.userId } }
    : null,
  payment_method: input.paymentMethod?.value ?? 0,
  due_date: input.dueDate ? input.dueDate.format(DATE_FORMAT) : '',
  invoice_date: moment(input.invoiceDate).format(DATE_FORMAT),
  invoice_attachments: input.invoiceAttachmentUuids,
  status: 1,
})
